<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b><u> الحسابات والأرباح</u> </b>
          </p>
        </v-flex>

        <!-- <v-flex xs12 sm6 md2>
                  <v-dialog
          ref="dialog_from"
          v-model="modal_from"
          :return-value.sync="date_from"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_from"
              label="تاريخ من"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_from" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal_from = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog_from.save(date_from)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
             </v-flex>
             <v-flex xs12 sm6 md2>
                  <v-dialog
          ref="dialog_to"
          v-model="modal_to"
          :return-value.sync="date_to"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_to"
              label="تاريخ الي"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_to" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal_to = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
             </v-flex>
      
             <v-flex xs12 sm6 md2>
                <v-btn @click="user_behavior">تأكيد</v-btn>
            </v-flex>
                        <br> -->

        <div></div>
      </v-layout>

      <v-data-iterator
        content-tag="v-layout"
        content-props="row wrap"
        :items="all_profit"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        no-data-text="Please select a product from the left hand menu to compare."
      >
        <v-flex slot="item" slot-scope="props">
          <v-card>
            <v-card-title>
              <h4>الربح الصافي :: {{ props.item.final_profit }}</h4>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>المبيعات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.sales
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>المرتجعات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.rebacks
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>الخصومات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.khasms
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>المشتريات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.buys
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>مرتجعات المشتريات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.buys_reback
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>صافي المبيعات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.final_sales
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>صافي المشتريات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.final_buy
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>مخزون اول مدة:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.start_item_cost
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>مخزون نهاية مدة:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.end_item_cost
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>تكلفة المبيعات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.sales_cost
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content
                  >الأرباح قبل المصروفات:</v-list-tile-content
                >
                <v-list-tile-content class="align-end">{{
                  props.item.profit
                }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>المصروفات:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{
                  props.item.masrofat
                }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
import { profit, user_behavior } from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الاكشن",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " المستخدم",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      },

      {
        text: "التاريخ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    // rowsPerPageItems: [11400, 11800],
    active: "",
    select_type: { id: "" },
    select_employer: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    fatworas: [],
    employers: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    omola_total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: "",
    select_user: {},
    types: [],
    all_profit: [],
    sales: "",
    rebacks: "",
    khasms: "",
    buys: "",
    buys_reback: "",
    final_sales: "",
    final_buy: "",
    start_item_cost: "",
    end_item_cost: "",
    sales_cost: "",
    profit: "",
    masrofat: "",
    final_profit: "",
    itemsPerPage: 4
  }),

  computed: {},

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    var frmData = new FormData();
    profit(frmData).then(res => {
      //   this.sales = res.data.sales;
      //   this.rebacks = res.data.rebacks;
      //   this.khasms = res.data.khasms;
      //   this.buys = res.data.buys;
      //   this.buys_reback = res.data.buys_reback;
      //   this.final_sales = res.data.final_sales;
      //   this.start_item_cost = res.data.start_item_cost;
      //   this.end_item_cost = res.data.end_item_cost;
      //   this.sales_cost = res.data.sales_cost;
      //   this.profit = res.data.profit;
      //   this.masrofat = res.data.masrofat;
      //   this.final_profit = res.data.final_profit;

      let inn = {
        sales: res.data.sales,
        rebacks: res.data.rebacks,
        khasms: res.data.khasms,
        buys: res.data.buys,
        buys_reback: res.data.buys_reback,
        final_sales: res.data.final_sales,
        final_buy: res.data.final_buy,
        start_item_cost: res.data.start_item_cost,
        end_item_cost: res.data.end_item_cost,
        sales_cost: res.data.sales_cost,
        profit: res.data.profit,
        masrofat: res.data.masrofat,
        final_profit: res.data.final_profit
      };
      this.all_profit.push(inn);
      console.log(this.all_profit);
      this.loading = false;
    });
  },

  methods: {
    user_behavior() {
      var frmData = new FormData();
      this.select_user.id && this.select_user.id != null
        ? frmData.append("user_id", this.select_user.id)
        : "";
      this.select_type.id && this.select_type.id != null
        ? frmData.append("type", this.select_type.id)
        : "";
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      user_behavior(frmData).then(response => {
        response.data.length > 0
          ? (this.fatworas = response.data)
          : (this.fatworas = []);
      });
    }
  }
};
</script>

<style scope>
.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 76px;
  font-size: 40px;
}

.v-list__tile:nth-child(even) {
  background-color: red !important;
}

.v-list__tile.theme--light {
  height: 76px;
  padding: 20px;
}

.v-card__title {
  height: 75px;
  font-size: 36px;
}
</style>
